import { Tooltip } from './ui/Tooltip';
import { getConfidenceMeta, getConfidenceLevel } from '../lib/confidenceLevel';

/**
 * PROD1.7.8 N3 — Badge de score de confiance global d'une extraction.
 *
 * Score ∈ [0, 1] (Decimal côté backend). Affiché en pourcentage 0–100%.
 * Couleurs et seuils centralisés dans `lib/confidenceLevel.ts` (4 niveaux
 * + unknown) — réutilisés par la colonne "Confiance" du tableau Documents
 * et par toutes les autres vues qui affichent un score d'extraction.
 */
interface ConfidenceScoreBadgeProps {
  score: number | null | undefined;
  /** Si true, affiche "Confiance : 87%" plutôt que juste "87%". */
  verbose?: boolean;
}

export function ConfidenceScoreBadge({ score, verbose = false }: ConfidenceScoreBadgeProps) {
  const meta = getConfidenceMeta(score);
  const level = getConfidenceLevel(score);

  if (level === 'unknown') {
    return (
      <Tooltip content={meta.tooltip}>
        <span className={`px-2 py-0.5 rounded text-xs border cursor-help ${meta.badgeClassName}`}>
          {verbose ? 'Confiance : ' : ''}—
        </span>
      </Tooltip>
    );
  }

  const num = typeof score === 'number' ? score : parseFloat(String(score));
  const pct = Math.round(num * 100);
  return (
    <Tooltip content={meta.tooltip}>
      <span className={`px-2 py-0.5 rounded text-xs border cursor-help ${meta.badgeClassName}`}>
        {verbose ? 'Confiance : ' : ''}
        {pct}%
      </span>
    </Tooltip>
  );
}
